import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

import { ButtonSmall, Spinner } from 'react-wot-bootstrap'
import Timer from 'components/Timer/Timer'

import { CANCEL, SORTIE_WITH_LEVEL } from 'helpers/i18n'
import { toRoman } from 'helpers'

import { getPlayerMatchingStatus, stopPlayerMatching } from 'state/actions/players_matching'

import { UNIT_MATCHING, WAITING_BATTLES_START } from './constants'

import styles from './WaitingPopover.scss'

export const POLL_INTERVAL_MS = 1000 * 30

export class WaitingPopover extends React.PureComponent {
    static propTypes = {
        vehicleLevel: PropTypes.number.isRequired,
        playersMatchingStart: PropTypes.instanceOf(moment),
        playersMatchingEnd: PropTypes.instanceOf(moment),
        handleCancel: PropTypes.func.isRequired,
        getStatus: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        this.handleUpdateProps()
    }

    componentDidUpdate = () => this.handleUpdateProps()

    handleUpdateProps = () => {
        if (!this.props.playersMatchingEnd || this.props.playersMatchingEnd <= moment()) {
            clearInterval(this.pollInterval)
        } else {
            this.initPollTimer(this.props.playersMatchingEnd)
        }
    }

    initPollTimer = () => {
        if (this.pollInterval) clearInterval(this.pollInterval)

        this.pollInterval = setInterval(this.props.getStatus, POLL_INTERVAL_MS)
    }

    componentWillUnmount = () => clearInterval(this.pollInterval)

    render() {
        let timer
        let description

        if (this.props.playersMatchingStart === null) {
            timer = null
            description = null
        } else if (this.props.playersMatchingStart > moment()) {
            timer = (
                <Timer
                    endTime={this.props.playersMatchingStart}
                    onExpire={this.forceUpdate.bind(this)}
                    shortFormat
                />
            )
            description = (
                <p className={styles.description}>{WAITING_BATTLES_START}</p>
            )
        } else {
            timer = (
                <Timer
                    startTime={this.props.playersMatchingStart}
                    shortFormat
                />
            )
            description = (
                <div className={styles.description}>
                    <p>{SORTIE_WITH_LEVEL(toRoman(this.props.vehicleLevel))}</p>
                    <p>{UNIT_MATCHING}</p>
                </div>
            )
        }

        return (
            <div className={styles.background}>
                <div className={styles.wrapper}>
                    <div className={styles.spinner}>
                        <Spinner />
                    </div>
                    <div className={styles.timer}>
                        {timer}
                    </div>
                    {description}
                    <div className={styles.button}>
                        <ButtonSmall type='secondary' onClick={this.props.handleCancel}>
                            {CANCEL}
                        </ButtonSmall>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ players_matching }) => ({
    vehicleLevel: players_matching.vehicle_level,
    playersMatchingStart: players_matching.start_time ? moment(players_matching.start_time) : null,
    playersMatchingEnd: players_matching.end_time ? moment(players_matching.end_time) : null,
})

const mapDispatchToProps = {
    handleCancel: stopPlayerMatching,
    getStatus: getPlayerMatchingStatus,
}

export default connect(mapStateToProps, mapDispatchToProps)(WaitingPopover)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/WaitingPopover.jsx